import { render, staticRenderFns } from "./topRetailSalesByCity.vue?vue&type=template&id=23e8c302&scoped=true&"
import script from "./topRetailSalesByCity.vue?vue&type=script&lang=js&"
export * from "./topRetailSalesByCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e8c302",
  null
  
)

export default component.exports